export default __webpack_public_path__ + "e49343f0bcfb860280ab61e01514eaa6.woff2";